import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Detail Berita")
  ])
], -1)

import { ref, onMounted } from "vue";
import { getStreamsDetail } from "@/views/berita/streams";
import { useRoute } from "vue-router";
import MedsosEdit from '@/views/berita/components/MedsosEdit.vue';
import ReviewAppsFormInput from '@/views/berita/components/ReviewAppsFormInput.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const source = ref('');
const id = ref(route.params.id);

// FUNCTION
async function getData() {
  const data_detail = await getStreamsDetail(id.value);
  source.value = data_detail.source;
}

onMounted(() => {
  getData();
});

return (_ctx: any,_cache: any) => {
  return (source.value == 'review')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(ReviewAppsFormInput)
      ]))
    : (_openBlock(), _createBlock(MedsosEdit, { key: 1 }))
}
}

})